module.exports = __webpack_public_path__ + "img/cafe-dulces.dabd7f85.jpeg";